import { ServiceState, ServiceType } from '@core/services/models/service.interface';
import { getLabel, getLogo } from '@core/services/helpers/services.helper';
import { ServiceConfigInterface } from '@core/services/models/service-config.interface';
import { serviceStateColor, serviceStateDescription, serviceStateLabel } from '@helpers/const/service-state';

export const SERVICES_CONFIG: ServiceConfigInterface[] = [
    {
        name: getLabel(ServiceType.PERFORMANCE_EASY),
        description: 'Zmaksymalizuj sprzedaż w sklepie i nie trać czasu na manualną obsługę działań reklamowych.',
        helpUrl: 'https://pomoc.onetads.pl/docs/seller',
        logo: getLogo(ServiceType.PERFORMANCE_EASY),
        type: ServiceType.PERFORMANCE_EASY,
        availableStates: [
            {
                type: ServiceState.INACTIVE,
                priority: 1,
                color: serviceStateColor[ServiceState.INACTIVE],
                name: serviceStateLabel[ServiceState.INACTIVE],
                description: serviceStateDescription[ServiceState.INACTIVE]
            },
            {
                type: ServiceState.BLOCKED,
                priority: 2,
                color: serviceStateColor[ServiceState.BLOCKED],
                name: serviceStateLabel[ServiceState.BLOCKED],
                description: serviceStateDescription[ServiceState.BLOCKED]
            },
            {
                type: ServiceState.CREATING,
                priority: 3,
                color: serviceStateColor[ServiceState.CREATING],
                name: serviceStateLabel[ServiceState.CREATING],
                description: serviceStateDescription[ServiceState.CREATING]
            },
            {
                type: ServiceState.VERIFYING,
                priority: 4,
                color: serviceStateColor[ServiceState.VERIFYING],
                name: serviceStateLabel[ServiceState.VERIFYING],
                description: serviceStateDescription[ServiceState.VERIFYING]
            },
            {
                type: ServiceState.WAITING_FOR_PIXEL,
                priority: 5,
                color: serviceStateColor[ServiceState.WAITING_FOR_PIXEL],
                name: serviceStateLabel[ServiceState.WAITING_FOR_PIXEL],
                description: serviceStateDescription[ServiceState.WAITING_FOR_PIXEL]
            },
            {
                type: ServiceState.WAITING_FOR_DATA,
                priority: 6,
                color: serviceStateColor[ServiceState.WAITING_FOR_DATA],
                name: serviceStateLabel[ServiceState.WAITING_FOR_DATA],
                description: serviceStateDescription[ServiceState.WAITING_FOR_DATA]
            },
            {
                type: ServiceState.INVALID_PAYMENT_METHOD,
                priority: 7,
                color: serviceStateColor[ServiceState.INVALID_PAYMENT_METHOD],
                name: serviceStateLabel[ServiceState.INVALID_PAYMENT_METHOD],
                description: serviceStateDescription[ServiceState.INVALID_PAYMENT_METHOD]
            },
            {
                type: ServiceState.ACTIVE,
                priority: 8,
                color: serviceStateColor[ServiceState.ACTIVE],
                name: serviceStateLabel[ServiceState.ACTIVE],
                description: serviceStateDescription[ServiceState.ACTIVE]
            }
        ]
    },
    {
        name: getLabel(ServiceType.SKAPIEC),
        description: 'Pozyskaj nowych klientów i zwiększaj sprzedaż. Promuj swoją ofertę w '
            + 'porównywarce cen odwiedzanej przez miliony użytkowników.',
        helpUrl: 'https://pomoc.onetads.pl/docs/us%C5%82uga-por%C3%B3wnywarka-sk%C4%85piec',
        logo: getLogo(ServiceType.SKAPIEC),
        type: ServiceType.SKAPIEC,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.LAMODA),
        description: 'Docieraj do użytkowników kochających zakupy w kategoriach moda, uroda i wnętrza. '
            + 'Promuj swoją ofertę, pozyskaj nowych klientów i zwiększaj sprzedaż.',
        helpUrl: 'https://pomoc.onetads.pl/docs/o-platformie',
        logo: getLogo(ServiceType.LAMODA),
        type: ServiceType.LAMODA,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.RETAIL_MEDIA),
        description: 'Wspieraj zwiększanie sprzedaży swoich produktów w najlepszych sklepach i '
            + 'serwisach partnerskich dzięki kampaniom reklamowym w sieci Retail Media.',
        helpUrl: 'https://pomoc.onetads.pl',
        logo: getLogo(ServiceType.RETAIL_MEDIA),
        type: ServiceType.RETAIL_MEDIA,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.OPINEO),
        description: 'Pokaż, że warto u Ciebie kupować! Zbieraj wiarygodne opinie, wzmacniaj swoją '
          + 'reputację i utrzymuj relacje z klientami dzięki narzędziom Opineo.',
        helpUrl: 'https://pomoc.onetads.pl/docs/wprowadzenie-2',
        logo: getLogo(ServiceType.OPINEO),
        type: ServiceType.OPINEO,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.VIDEO_ADS),
        description: 'Powierzchnie reklamowe premium na najbardziej znanych portalach takich jak m.in. Newsweek, '
            + 'Onet i Fakt czekają na Twoje video!',
        helpUrl: 'https://pomoc.onetads.pl/docs/wprowadzenie-5',
        logo: getLogo(ServiceType.VIDEO_ADS),
        type: ServiceType.VIDEO_ADS,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.MAILING),
        description: 'Docieraj do tych, którzy naprawdę kupują lub pokaż swoją markę milionom użytkowników Onet Poczty.',
        helpUrl: 'https://pomoc.onetads.pl/docs/wprowadzenie-6',
        logo: getLogo(ServiceType.MAILING),
        type: ServiceType.MAILING,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.MAILING_INBOX),
        description: 'Wyświetl reklamę w skrzynce odbiorczej użytkowników Onet Poczty. Kliknięcie w tytuł'
            + ' przekierowuje odbiorcę na Twoją stronę - nie potrzebujesz kreacji.',
        helpUrl: 'https://pomoc.onetads.pl/docs/wprowadzenie-6',
        logo: getLogo(ServiceType.MAILING_INBOX),
        type: ServiceType.MAILING_INBOX,
        availableStates: []
    },
    {
        name: getLabel(ServiceType.MAILING_RETARGETING),
        description: 'Klient oglądał produkty w Twoim sklepie, ale nie kupił? '
            + 'Dzięki mailingowi e-commerce możesz dotrzeć do niezdecydowanych '
            + 'klientów i zmotywować ich do dokończenia zakupu.',
        helpUrl: 'https://pomoc.onetads.pl/docs/wprowadzenie-6',
        logo: getLogo(ServiceType.MAILING_RETARGETING),
        type: ServiceType.MAILING_RETARGETING,
        availableStates: []
    }
];
